import React from 'react'
import uuid from 'uuid'
import WPBlock from '../../components/WPBlock'

const NumberedCard = ({ block }) => {
  if (!block || !block.attrs.number || !block.innerBlocks) {
    return null
  }

  return (
    <div className="card--default is-numbered">
      <div className="card-content">
        <span className="text-dfs text-2xl font-semibold">
          0{block.attrs.number}
        </span>
        <div className="space-y-2">
          {block.innerBlocks.map(innerBlock => {
            const key = uuid.v4()
            return <WPBlock key={key} block={innerBlock} />
          })}
        </div>
      </div>
    </div>
  )
}

export default NumberedCard
